export default __webpack_public_path__ + "static/img_en-597fdf720cfba5c32072abd42f03f83f.gif";